import { Graphics } from "pixi.js";

/** Paleta Adidas Tango (Rosario / España 78). */
export const TANGO = {
  WHITE: 0xf7f7f5,
  BLACK: 0x141414,
  HIGHLIGHT: 0xffffff,
  EDGE: 0xb0b0ac,
} as const;

type XY = [number, number];

function rot(x: number, y: number, angle: number, ox: number, oy: number): XY {
  const c = Math.cos(angle);
  const s = Math.sin(angle);
  return [ox + x * c - y * s, oy + x * s + y * c];
}

/** Triángulo curvo característico del Tango (triada). */
function drawTriad(g: Graphics, size: number, angle: number, ox: number, oy: number): void {
  const h = size;
  const w = size * 0.84;

  const tip = rot(0, -h, angle, ox, oy);
  const rMid = rot(w, h * 0.15, angle, ox, oy);
  const rBase = rot(w * 0.62, h * 0.95, angle, ox, oy);
  const base = rot(0, h * 1.06, angle, ox, oy);
  const lBase = rot(-w * 0.62, h * 0.95, angle, ox, oy);
  const lMid = rot(-w, h * 0.15, angle, ox, oy);

  g.moveTo(tip[0], tip[1]);
  g.quadraticCurveTo(rMid[0], rMid[1], rBase[0], rBase[1]);
  g.quadraticCurveTo(base[0], base[1], lBase[0], lBase[1]);
  g.quadraticCurveTo(lMid[0], lMid[1], tip[0], tip[1]);
  g.fill(TANGO.BLACK);

  const stripe = (inset: number, spread: number): void => {
    const a = rot(-w * spread, h * inset, angle, ox, oy);
    const b = rot(0, -h * (0.55 - inset * 0.15), angle, ox, oy);
    const c = rot(w * spread, h * inset, angle, ox, oy);
    g.moveTo(a[0], a[1]);
    g.quadraticCurveTo(b[0], b[1], c[0], c[1]);
    g.stroke({ width: Math.max(0.6, size * 0.09), color: TANGO.WHITE, alpha: 0.95 });
  };

  stripe(0.42, 0.38);
  stripe(0.62, 0.28);
}

/** Tres triadas convergiendo en un círculo (motivo Tango). */
function drawTangoRing(
  g: Graphics,
  cx: number,
  cy: number,
  triadSize: number,
  ringR: number,
  offset = 0,
): void {
  for (let i = 0; i < 3; i++) {
    const angle = offset + (i * Math.PI * 2) / 3;
    const tx = cx + Math.cos(angle) * ringR;
    const ty = cy + Math.sin(angle) * ringR;
    drawTriad(g, triadSize, angle + Math.PI, tx, ty);
  }
}

/** Balón Tango: anillos de triadas sobre base blanca. */
export function drawTango(g: Graphics, r: number): void {
  g.clear();
  g.circle(0, 0, r).fill(TANGO.WHITE);
  g.circle(-r * 0.2, -r * 0.22, r * 0.4).fill({ color: TANGO.HIGHLIGHT, alpha: 0.26 });

  drawTangoRing(g, 0, -r * 0.12, r * 0.3, r * 0.24, -Math.PI / 2);
  drawTangoRing(g, -r * 0.4, r * 0.32, r * 0.26, r * 0.19, Math.PI / 6);
  drawTangoRing(g, r * 0.4, r * 0.32, r * 0.26, r * 0.19, -Math.PI / 6);
  drawTangoRing(g, 0, r * 0.46, r * 0.22, r * 0.17, Math.PI / 2);

  g.circle(0, 0, r).stroke({ width: Math.max(1, r * 0.045), color: TANGO.EDGE, alpha: 0.85 });
}
